var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card class chart"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("分销数据")])]),_c('div',{staticClass:"chart",attrs:{"id":"distributeDataCharts"}})])
}]

export { render, staticRenderFns }